<app-settings-card
  [showFooter]="false"
  heading="Subscription"
  description="Im Payment Portal kannst du deine Subscription bearbeiten. Für Up- und Downgrades und weitere Anliegen helfen wir dir gerne per Mail weiter."
  >
  <div class="flex my-8 gap-4">
    <a [href]="link + suffix" appTailwindButton color="primary">Payment Portal</a>
    <a href="mailto:support@jessie.ai" appTailwindButton color="primary">Support per Mail</a>
  </div>

  <!-- for test subscription update - only visible to admins -->
  @if (isAdmin$ | async) {
    <div class="flex flex-col gap-4 mt-4">
      <div class="flex items-center gap-4">
        <input
          [ngModel]="targetOrgaId$ | async"
          (ngModelChange)="targetOrgaId$.next($event)"
          type="text"
          placeholder="Enter Orga ID"
          class="px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        <button
          (click)="enableTestSubscription()"
          appTailwindButton
          color="primary"
          [disabled]="!(targetOrgaId$ | async)"
          >
          Enable Test Subscription
        </button>
      </div>
      <!-- Error message -->
      @if (errorMessage$ | async) {
        <div class="text-red-500 text-sm">
          {{ errorMessage$ | async }}
        </div>
      }
    </div>
  }
</app-settings-card>
